import React from "react"
import AntdParagraph from "antd/lib/typography/Paragraph"

export const Paragraph = ({ children, className, type }) => (
  <AntdParagraph className={className} type={type}>
    {children}
  </AntdParagraph>
)
